export default __webpack_public_path__ + "static/media/LCDImg.63e59fb4.jpg";